module.exports = __webpack_public_path__ + "img/11.909fbc45.png";